import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import type { SettingsHubHelpItem } from '../../modules/configuration-settings/models';

export interface HelpItemsProps {
  items?: SettingsHubHelpItem[];
  className?: string;
}

const HelpItems: React.FC<HelpItemsProps> = ({ items, className }) => {
  const { colors } = useTheme();

  if (!items?.length) return null;

  return (
    <div className={cn('space-y-0', className)}>
      {items.map((item, i) => (
        <details key={i} className="group max-w-3xl pt-1">
          <summary
            className={cn(
              'cursor-pointer list-none text-xs font-medium outline-none',
              colors.textMuted,
              'marker:content-none [&::-webkit-details-marker]:hidden',
            )}
          >
            <span
              className={cn(
                'underline decoration-dotted underline-offset-2 group-open:font-medium',
                colors.primaryFg,
              )}
            >
              {item.summary}
            </span>
          </summary>
          <div className={cn('mt-2 text-xs leading-relaxed', colors.textMuted)}>
            {item.content}
            {item.readMoreHref ? (
              <p className="mt-2">
                <a
                  href={item.readMoreHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn('font-medium underline underline-offset-2', colors.primaryFg)}
                >
                  Read full guide →
                </a>
              </p>
            ) : null}
          </div>
        </details>
      ))}
    </div>
  );
};

export default HelpItems;
